export const isMounted = () => (window ? true : false);
